import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MessagingStatLog } from 'src/app/models/MessagingStatLog';
import { MessagingService } from 'src/app/services/messaging.service';

@Component({
  selector: 'app-send-email-packet',
  templateUrl: './send-email-packet.component.html',
  styleUrls: ['./send-email-packet.component.less']
})
export class SendEmailPacketComponent {

  @Input() datas: MessagingStatLog;
  $error: Subscription;

  constructor(public mess: MessagingService, public toast: ToastrService, public modalService: NgbModal) 
  {
  
  }
  ngOnDestroy(): void {
    if(this.$error) this.$error.unsubscribe();
  }
  ngOnInit(): void {
    console.log(this.datas);
  }

  sendPacket() {
    this.$error = this.mess.sendEmailPacket(this.datas).pipe(tap(_ => {
      this.toast.success('Packet queued to send!');
      this.datas.errorResolved = true; 
      this.modalService.dismissAll();
    },
    e => {
      this.toast.error('Error sending email packet', '', { closeButton: true, disableTimeOut: true });
    },
    () => {})).subscribe();
  }
}
